import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers-actions-menu.types";
import { EllipsisMenu } from "@edgetier/client-components";
import EllipsisMenuAction from "components-for/action-menu/ellipsis-menu-action";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import DeletePhraseTriggerAction from "../delete-phrase-trigger-action";
import "./phrase-triggers-actions-menu.scss";

/**
 * A dropdown menu to remove a phrase trigger
 * @param props.user        User selected to edit or reinvite
 */
const PhraseTriggersActionsMenu: FunctionComponent<IProps> = ({ phraseTriggerId }) => {
    return (
        <div className="phrase-triggers-actions-menu">
            <EllipsisMenu placement="bottom-end" overflowContainer>
                <EllipsisMenuAction
                    icon={faTrash}
                    modalTitle="Delete Phrase Trigger"
                    actionLabel="Delete Phrase Trigger"
                >
                    {(closeModal) => (
                        <DeletePhraseTriggerAction phraseTriggerId={phraseTriggerId} closeModal={closeModal} />
                    )}
                </EllipsisMenuAction>
            </EllipsisMenu>
        </div>
    );
};

export default memo(PhraseTriggersActionsMenu);
